import React, { useState, useEffect, useContext } from 'react';

import Skeleton from 'react-loading-skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { classNameTriskeleParser } from '../../utilities/customStyles';

import 'react-loading-skeleton/dist/skeleton.css';
import { useLocation, useNavigate } from 'react-router-dom';
import globalContext from '../../context/GlobalContext';
import ProfileAccess from '../../dataAccess/ProfileAccess';
import { EMPTY_PROFILE_PIC } from '../../utilities/generatedClasses';
import { setDrawer } from '../../redux/actions/drawerActions';
import { overlayTopSide, unOverlayTopSide } from '../../utilities/utils';
import { setUserProfile } from '../../redux/actions/userProfileAction';
import ProfileView from '../../screens/Profile/ProfileView';

const ProfileHeader = (props) => {
const [header, setHeader] = useState(null);
const [isInDashboardPage, setIsInDashboardPage] = useState(false);
const [isShowingProfile, setShowProfile] = useState(false);
const [panelProfileType, setPanelProfileType] = useState(null); // 'client' | 'provider'
const [panelProviderId, setPanelProviderId] = useState(null);
const context = useContext(globalContext);
const userProfileState = useSelector(state => state.userProfile);
const [isUserProfile, setIsUSerProfile] = useState(false);
const navigate = useNavigate();
const { clientId } = props;

const setHeaderFromResponse = (response) => {
  const headerData = response.data[0];
  if (headerData) {
    headerData.triskeleClass = {
      text:  classNameTriskeleParser(headerData.VisualNameOne, headerData.VisualTypeOne, 'Text'),
      button: classNameTriskeleParser(headerData.VisualNameTwo, headerData.VisualTypeTwo, 'Card')
    };
  }

  setHeader(headerData);
};


const getClientHeader = () => {
  ProfileAccess.getClientHeader(clientId)
    .then((response) => {
      if (response?.data?.length > 0 && response.data[0]?.FieldValue) {
        window.clientDate = response.data[0].FieldValue;
      } else {
        window.clientDate = null;
      }
      setHeaderFromResponse(response);
    })
    .catch((error) => {
      console.error(error);
      context.navigation.push('/maintenance');
    });
};

const showProfile = () => {
  setPanelProfileType('client');
  document.getElementById('scrollContainer').style.overflowY = 'hidden';
  setShowProfile(true);
};

const dispatch = useDispatch();

const hideProfile = () => {
  dispatch(setUserProfile(null));
  setPanelProfileType(null);
  setPanelProviderId(null);
  document.getElementById('scrollContainer').style.overflowY = 'scroll';
  setShowProfile(false);
};

const drawerAction = useSelector(state => state.drawer);

const opencloseDrawer = () => {
  if (drawerAction === false) {
    overlayTopSide();
    dispatch(setDrawer(true));
  } else {
    unOverlayTopSide();
    dispatch(setDrawer(false));
  }
};

const callTriskeleApi = () => {
  if (props.header != null) {
    setIsInDashboardPage(false);
    setHeader(props.header);
  } else {
    setIsInDashboardPage(true);
    getClientHeader();
  }
};

useEffect(() => {
  callTriskeleApi();
}, []);

  const location = useLocation();

useEffect(() => {
  if (location.pathname.includes('recommendation')){
    callTriskeleApi();
  }
}, [location]);


useEffect(() => {
  if (drawerAction === true) {
    setIsUSerProfile(true);
  } else {
    setIsUSerProfile(false);
  }
  if (userProfileState != null) {
    setPanelProviderId(userProfileState);
    setPanelProfileType('provider');
    document.getElementById('scrollContainer').style.overflowY = 'hidden';
    setShowProfile(true);
  }
}, [userProfileState]);

return (
  <>
    <div
      id="profile-header-box"
      className="profile-header-box "
      style={{ backgroundColor: '#FAFAFa' }}
  >

      {!header && ( // skeleton
      <>
        <span className="profile-header-skeleton-user">
          <Skeleton circle className="profile-header-skeleton-user-image" />
          <Skeleton className="profile-header-skeleton-user-text" />
        </span>
        <Skeleton borderRadius="1rem" className="profile-header-skeleton-button" />
      </>
      )}
      {header && ( // regular
      <>
        <div className='profile-container-one' >
          <div
            onClick={opencloseDrawer}
            aria-hidden
            className={`logo-img ${classNameTriskeleParser('Prism Logo', 'Default', 'Image')}`} />
          {isInDashboardPage
          && (
          <span className="profile-header-main-user" onClick={showProfile} aria-hidden="true">
            <span
              className={`profile-header-main-user-text ${header.triskeleClass.text} `}
              style={{ marginRight: '10px' }}
          >
              {header.ClientHeader}
            </span>
            {
              header.ProfilePicture
                ? (
                  <img
                    alt="profile"
                    className="profile-header-main-user-image"
                    src={header.ProfilePicture}
              />
                )
                : <div className={`size-30 ${EMPTY_PROFILE_PIC}`} />
            }


          </span>
          )
          }

          {!isInDashboardPage && (
            <span style={{ padding: '10px 0' }} className={`profile-header-main-user ${header != null ? classNameTriskeleParser(header.VisualNameOne, header.VisualTypeOne, 'Text') : ''}`}>
                {header.PageTitle}
            </span>
          )
          }
        </div>
        {isInDashboardPage
          && (
          <span
            className={`profile-header-main-button ${classNameTriskeleParser(header.VisualNameTwo, header.VisualTypeTwo, 'Card' )}`}
          >
            {header.Status}
          </span>
          )
        }
      </>
      )}
    </div>
    {isShowingProfile && (
      <div className="header__curtain__black header__curtain">
        <ProfileView
          panelClientId={panelProfileType === 'client' ? clientId : undefined}
          panelProviderId={panelProfileType === 'provider' ? panelProviderId : undefined}
          panelClientContext={clientId}
          close={hideProfile}
          isUserProfile={isUserProfile}
        />
      </div>
    )}

  </>

);
};
export default ProfileHeader;
